const CriticReviewQuotation = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="32"
    viewBox="0 0 35 32"
    fill="none"
  >
    <path
      d="M31.125 16.0041L31.1281 15.501L30.625 15.501L21.8751 15.501C20.9624 15.501 20.1876 14.7221 20.1876 13.7152L20.1876 2.28586C20.1876 1.27892 20.9624 0.500001 21.8751 0.500001L32.8125 0.500002C33.7252 0.500002 34.5 1.27892 34.5 2.28586L34.5 15.8365C34.5 20.8077 33.3327 24.2749 31.7122 26.6987C30.0914 29.1229 27.9933 30.5393 26.0726 31.3688C25.2257 31.7291 24.24 31.3238 23.878 30.406L23.8778 30.4053C23.5103 29.4773 23.94 28.4327 24.7966 28.0632L24.7967 28.0631C26.9098 27.1508 28.4948 25.688 29.5485 23.6591C30.5965 21.6411 31.1061 19.0884 31.125 16.0041Z"
      fill="#8000FF"
      stroke="#F0F0F0"
    />
    <path
      d="M11.4375 16.0041L11.4406 15.501L10.9375 15.501L2.18758 15.501C1.27487 15.501 0.500099 14.7221 0.500099 13.7152L0.5001 2.28586C0.5001 1.27892 1.27487 0.500001 2.18759 0.500001L13.125 0.500002C14.0377 0.500002 14.8125 1.27892 14.8125 2.28586L14.8125 15.8365C14.8125 20.8065 13.6452 24.2737 12.0247 26.6979C10.4039 29.1224 8.30574 30.5394 6.38514 31.3688C5.53817 31.7291 4.55248 31.3238 4.19052 30.406L4.19028 30.4053C3.82284 29.4773 4.25254 28.4327 5.10909 28.0632L5.1092 28.0631C7.22232 27.1508 8.80729 25.688 9.86096 23.6591C10.909 21.6411 11.4186 19.0884 11.4375 16.0041Z"
      fill="#8000FF"
      stroke="#F0F0F0"
    />
  </svg>
);

export default CriticReviewQuotation;
